// Surfaces the running UI, API and database script versions for display to the user.
// - UI version comes from config (config/ui.env -> settings.js -> environmentSettings.appVersion),
//   so the running build is verifiable; it falls back to the build-time injected value.
// - API and database versions are fetched from the anonymous /Version endpoint (available pre-login),
//   which reads them from the API configuration (config/api.env -> appsettings.json).

export interface IApiVersionInfo {
  name: string;
  version: string;
  databaseVersion?: string;
}

export interface IVersions {
  apiVersion: string;
  databaseVersion: string;
}

export function getUiVersion(): string {
  const fromConfig = typeof environmentSettings === 'undefined' ? undefined : environmentSettings.appVersion;
  return fromConfig || process.env.APP_VERSION || 'unknown';
}

export async function getApiVersionInfo(): Promise<IVersions> {
  try {
    const response = await fetch(`${environmentSettings.apiUrl}Version`, {
      method: 'GET',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });

    if (!response.ok) {
      return { apiVersion: 'unknown', databaseVersion: 'unknown' };
    }

    const data: IApiVersionInfo = await response.json();
    return {
      apiVersion: data.version || 'unknown',
      databaseVersion: data.databaseVersion || 'unknown'
    };
  } catch {
    return { apiVersion: 'unknown', databaseVersion: 'unknown' };
  }
}
